import React from "react";

//styles
import "./css/Footer.css";

function Footer() {
  return (
    <div className="footer">
      <h2>
        W<span>COM</span>
      </h2>
      <div className="footerContent">
        <div className="text">
          <h3>world wide delivery</h3>
          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Facere
            maxime perferendis, veniam quia qui tenetur eius molestias dolorem
            fugit explicabo et minus. Repellendus natus nam ipsum dolorem
            possimus. Facilis, ab.
          </p>
        </div>
        <div className="text">
          <h3>24/7 technical support</h3>
          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Facere
            maxime perferendis, veniam quia qui tenetur eius molestias dolorem
            fugit explicabo et minus. Repellendus natus nam ipsum dolorem
            possimus. Facilis, ab.
          </p>
        </div>
        <div className="text">
          <h3>customer loyality programs</h3>
          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Facere
            maxime perferendis, veniam quia qui tenetur eius molestias dolorem
            fugit explicabo et minus. Repellendus natus nam ipsum dolorem
            possimus. Facilis, ab.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
